import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'

import useStyles from './styles'

/**
 * NativeScrollbar
 *
 * Scrollbar nativo estilizado, sem dependências externas.
 *
 * @param {object}  containerRef     - Ref do elemento scrollável
 * @param {string}  axis             - Eixo de scroll: 'y' | 'x' | 'both' (padrão: 'y')
 * @param {number}  thickness        - Espessura da scrollbar em px (padrão: 6)
 * @param {string}  thumbColor       - Cor do thumb (padrão: rgba(0,0,0,0.2))
 * @param {string}  thumbColorHover  - Cor do thumb no hover (padrão: rgba(0,0,0,0.35))
 * @param {string}  trackColor       - Cor do trilho (padrão: transparent)
 * @param {number}  thumbRadius      - Border-radius do thumb em px (padrão: 3)
 * @param {boolean} autoHide         - Oculta a scrollbar até o hover (padrão: false)
 * @param {string}  height           - Altura do container (padrão: '100%')
 * @param {string}  maxHeight        - Altura máxima do container
 */
const NativeScrollbar = ({
  children,
  className,
  containerRef,
  axis = 'y',
  thickness = 6,
  thumbColor = 'rgba(0, 0, 0, 0.2)',
  thumbColorHover = 'rgba(0, 0, 0, 0.35)',
  trackColor = 'transparent',
  thumbRadius = 3,
  autoHide = false,
  height = '100%',
  maxHeight,
  ...rest
}) => {
  const classes = useStyles({
    axis,
    thickness,
    thumbColor,
    thumbColorHover,
    trackColor,
    thumbRadius,
    autoHide,
    height,
    maxHeight,
  })

  return (
    <div ref={containerRef} className={clsx(classes.root, className)} {...rest}>
      {children}
    </div>
  )
}

NativeScrollbar.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  containerRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  ]),
  axis: PropTypes.oneOf(['x', 'y', 'both']),
  thickness: PropTypes.number,
  thumbColor: PropTypes.string,
  thumbColorHover: PropTypes.string,
  trackColor: PropTypes.string,
  thumbRadius: PropTypes.number,
  autoHide: PropTypes.bool,
  height: PropTypes.string,
  maxHeight: PropTypes.string,
}

export default NativeScrollbar
